// The admin console is its own experience, separate from the public site: it has its own header
// and none of the site's floating extras (rental toasts, install prompts, bottom nav).
export const isAdminPath = (pathname: string): boolean => pathname === '/admin' || pathname.startsWith('/admin/')
